var _ellipse, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 15,
    rx: 16,
    ry: 15,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6240_6138",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 15,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0166 8H23.0449V22H9.0166V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6240_6138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0639 8.65625H22.2152L17.5157 14.0303L23.0449 21.3442H18.7162L15.3233 16.9093L11.4455 21.3442H9.29216L14.3183 15.5942L9.0166 8.65725H13.4556L16.5177 12.7102L20.0639 8.65625ZM19.3073 20.0562H20.4998L12.8042 9.87725H11.5257L19.3073 20.0562Z",
    fill: "#253B57"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterNew);
export default __webpack_public_path__ + "static/media/twitter_new.ea6fb145e84a7a1a4c724852ffa3a6fc.svg";
export { ForwardRef as ReactComponent };